import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConnectorsData } from '../store/helps/fetchConnectorsData';
import { initTexts } from '../store/redux/translate-actions';
import { getMessages, getStudyGroup, getFakeEntities, getUserBoardAccess } from '../store/redux/entities-action';
import { getMetaData, fetchUsefulTools, fetchPermissionList, fetchPermissionFilters, fetchShortcut, fetchTeachingAssistantBots } from '../store/redux/uiData-actions';
import { useLocation } from 'react-router-dom';
import { isRouteShouldFetch } from '../utils/utils';

const useDataInitialization = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { isAuth } = useSelector(state => state.auth);
    const { providers } = useSelector(state => state.uiData);
    const { isStudent } = useSelector(state => state.auth);
    const { lang } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);

    const fetchStaticJsonData = () => {
        dispatch(getMetaData());
        dispatch(fetchUsefulTools());
        dispatch(fetchPermissionList());
        dispatch(fetchPermissionFilters());
        dispatch(fetchShortcut());
        dispatch(fetchTeachingAssistantBots());
    };

    useEffect(() => {
        if (providers && isAuth === true && isRouteShouldFetch() && !window.hasFetchedConnectorsOnce) {
            window.hasFetchedConnectorsOnce = true;
            dispatch(fetchConnectorsData());
            dispatch(getFakeEntities());
        }
    }, [providers, isAuth, pathname, dispatch]);

    useEffect(() => {
        if (isAuth !== null && lang && (userDetails || isAuth === false)) {
            dispatch(initTexts());
        }
    }, [dispatch, isAuth, lang, userDetails]);

    useEffect(() => {
        if (isAuth === true && isStudent !== null && isRouteShouldFetch() && !window.hasFetchedDataOnce) {
            window.hasFetchedDataOnce = true;
            dispatch(getStudyGroup(isStudent));
        }
    }, [isAuth, isStudent, pathname, dispatch]);

    useEffect(() => {
        if (isAuth === true && isRouteShouldFetch() && !window.hasFetchedDataInitOnce) {
            window.hasFetchedDataInitOnce = true;
            fetchStaticJsonData();
            dispatch(getUserBoardAccess());
        }
    }, [isAuth, isStudent, pathname, dispatch]);

    useEffect(() => {
        if (isAuth === true && userDetails !== null && lang && isRouteShouldFetch())
            dispatch(getMessages({
                fromClass: userDetails?.defaultSchool?.fromClass || 1,
                toClass: userDetails?.defaultSchool?.toClass || 12,
                lang,
            }));
    }, [userDetails?.defaultSchool, lang, dispatch]);

};

export default useDataInitialization; 